<script setup>
import { useI18n } from "vue-i18n";
import { FormRadioGroup, FormRadioGroupOption } from "@Components/Form";

defineProps(["modelValue"]);
defineEmits(["update:modelValue"]);

const { t: __ } = useI18n();

const orders = [
    {
        key: "rand",
        name: __("Aléatoire"),
        description: __("Afficher les articles de façon aléatoire."),
    },
    {
        key: "date",
        name: __("Dernières publications"),
        description: __("Afficher les derniers articles publiées."),
    },
];
</script>

<template>
    <FormRadioGroup v-model="modelValue.orderby" :label="__('Ordre d\'affichage')">
        <div class="grid grid-cols-1 gap-6 lg:grid-cols-3 sm:grid-cols-2">
            <FormRadioGroupOption v-for="order in orders" :key="order.key" :value="order.key" :title="order.name" :description="order.description" />
        </div>
    </FormRadioGroup>
</template>
